import { useEffect, useState } from 'react';
import { Alert, Button, Spin } from '@arco-design/web-react';
import { errorMessage } from '../../../common/api/httpClient';
import { personalApi } from '../api/personalApi';
import type { PortalPersonalProfile } from '../model/personalModels';
import { PortalPersonalView } from '../views/PortalPersonalView';

export function PortalPersonalPage(props: { onPasswordChanged: () => void }) {
  const [profile, setProfile] = useState<PortalPersonalProfile>();
  const [error, setError] = useState<string>();
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let active = true;
    setError(undefined);
    void personalApi.profile()
      .then(result => { if (active) setProfile(result); })
      .catch(cause => { if (active) setError(errorMessage(cause)); });
    return () => { active = false; };
  }, [reloadKey]);

  if (!profile && !error) {
    return <div className="portal-personal-config__loading"><Spin loading tip="正在加载个人信息..." /></div>;
  }
  if (!profile) {
    return <div className="portal-personal-config__loading">
      <Alert type="error" content={error ?? '个人信息加载失败'} />
      <Button onClick={() => setReloadKey(key => key + 1)}>重新加载</Button>
    </div>;
  }
  return <PortalPersonalView profile={profile}
    onPasswordChanged={props.onPasswordChanged} />;
}
